<template>
  <div v-if="sheetVisible" class="pwa-install-mask" @click.self="dismissInstallSheet">
    <div class="pwa-install-sheet" role="dialog" aria-labelledby="pwa-install-title">
      <!-- 설치 완료: 앱으로 접속 안내 -->
      <template v-if="installDone">
        <div class="pwa-install-brand">
          <img :src="iconSrc" alt="카이온" class="pwa-install-icon" />
        </div>
        <h2 id="pwa-install-title" class="pwa-install-title">설치가 완료되었습니다</h2>
        <p class="pwa-install-desc">
          홈 화면에 카이온 앱이 생겼습니다.<br />
          이제 <b>브라우저가 아닌 카이온 앱을 열어</b> 접속해 주세요.<br />
          앱에서 알림을 받을 수 있습니다.
        </p>
        <div class="pwa-install-actions">
          <button type="button" class="app-btn primary pwa-install-ok" @click="dismissInstallSheet">
            확인
          </button>
        </div>
      </template>

      <!-- 설치 안내 -->
      <template v-else>
        <div class="pwa-install-brand">
          <img :src="iconSrc" alt="카이온" class="pwa-install-icon" />
        </div>
        <h2 id="pwa-install-title" class="pwa-install-title">
          {{ fromSms || isSmsFlow ? '앱을 설치하시겠습니까?' : '앱으로 설치' }}
        </h2>
        <p class="pwa-install-desc">
          <template v-if="isInApp">
            지금 창에서는 설치할 수 없습니다. 아래 버튼으로 브라우저를 연 뒤 설치해 주세요.
          </template>
          <template v-else-if="fromSms || isSmsFlow">
            문자로 받으신 링크입니다. 카이온 앱으로 설치하면 알림과 바로가기를 편하게 쓸 수 있어요.
          </template>
          <template v-else>
            홈 화면에 카이온을 추가하면 앱처럼 바로 열고 알림도 받을 수 있습니다.
          </template>
        </p>

        <p v-if="installGuide?.label" class="pwa-install-browser">
          {{ installGuide.label }}
        </p>

        <ol
          v-if="showManualSteps || (!canNativePrompt && !isInApp)"
          class="pwa-install-steps"
        >
          <li v-for="(step, i) in installGuide?.steps || []" :key="i">{{ step }}</li>
        </ol>

        <p v-if="showManualSteps || (!canNativePrompt && !isInApp)" class="pwa-install-afternote">
          추가가 끝나면 <b>홈 화면의 카이온 앱</b>을 열어 접속해 주세요.
        </p>

        <div class="pwa-install-actions">
          <button type="button" class="app-btn ghost pwa-install-later" @click="dismissInstallSheet">
            나중에
          </button>
          <button type="button" class="app-btn primary pwa-install-ok" @click="onInstall">
            {{ primaryInstallLabel }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import iconSrc from '@/assets/images/brand/caion-app-icon.png'
import {
  bootstrapPwaInstall,
  dismissInstallSheet,
  promptInstall,
  teardownPwaInstallTimers,
  usePwaInstall,
} from '@/composables/usePwaInstall'

const {
  sheetVisible,
  isInApp,
  fromSms,
  isSmsFlow,
  installGuide,
  showManualSteps,
  canNativePrompt,
  primaryInstallLabel,
  installDone,
} = usePwaInstall()

const onInstall = async () => {
  await promptInstall()
}

onMounted(() => {
  bootstrapPwaInstall()
})

onUnmounted(() => {
  teardownPwaInstallTimers()
})
</script>
